export const getRole = () => sessionStorage.getItem("adminRole") || "";
export const isAdmin = () => getRole() === "admin";

export const getAdminId = () => {
  const token = sessionStorage.getItem("adminToken");
  if (!token) return "";
  try {
    return JSON.parse(atob(token.split(".")[1])).id || "";
  } catch {
    return "";
  }
};
